import { registerWeapon } from './registry';
import { HUGE_CRATER } from '../terrain/crater-shapes';

const HEAVY_SHELL = registerWeapon({
  id: 'heavy_shell',
  name: 'Heavy Shell',
  description: 'Slow but devastating. Massive knockback.',
  tier: 'UNCOMMON',
  rarity: 'uncommon',
  projectileRadius: 12,
  projectileSpeed: 0.35,
  color: 0xff6600,
  gravity: 0.22,
  bounces: 0,
  bounceEnergyRetention: 0.85,
  damage: 52,
  blastRadius: 130,
  knockbackMult: 0.14,
  knockbackRadius: 1.4,
  shakeIntensity: 2.0,
  particleScale: 2.0,
  craterShape: HUGE_CRATER,
  canDestroyWireframe: true,
  wireframeDamageScale: 0.4,
});
